import { render, staticRenderFns } from "./AssociationsPanel.vue?vue&type=template&id=ba414be6&scoped=true"
import script from "./AssociationsPanel.vue?vue&type=script&lang=js"
export * from "./AssociationsPanel.vue?vue&type=script&lang=js"
import style0 from "./AssociationsPanel.vue?vue&type=style&index=0&id=ba414be6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba414be6",
  null
  
)

export default component.exports